<div bsModal
     #historyStatusModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header no-border">
                {{ l('StatusHistory')}}
            </div>
            <div class="modal-body no-border">
                <div class="container">
                    <div *ngFor="let status of history"
                         class="status-box">
                        <app-status-details 
                            [status]="status.newStatus"
                            [date]="status.statusChange"
                            [whoChanged]="status.whoChange.firstName + ' ' + status.whoChange.lastName"
                            [standaloneMode]="true"></app-status-details>
                    </div>
                </div>
            </div>

            <div class="modal-footer no-border">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="close()">
                    {{l("Close")}}
                </button>
            </div>
        </div>
    </div>
</div>
